import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiResponse, post, tokenStore } from '../../api/request';
import type { LoginReqData, LoginResponse } from '../../api/responses';

export interface StoreInfo {
  storeId:     string;
  storeName:   string;
  ownerName:   string;
  email:       string;
  role:        string;
  accessToken: string;
}

interface AuthState {
  isLoggedIn: boolean;
  loading:    boolean;
  error:      string | null;
}

const initialState: AuthState = {
  isLoggedIn: false,
  loading:    false,
  error:      null,
};

// ── 로그인 async thunk ────────────────────────────────────────
/**
 * 로그인 요청을 서버에 보내는 async thunk
 * - 아이디/비밀번호를 서버로 전송
 * - 성공 시 accTkn, rfrTkn을 tokenStore에 저장하고 LoginData를 반환
 * - 실패 시 ApiError를 throw
 */
export const performLogin = createAsyncThunk<
  LoginResponse,                          // 반환 타입
  LoginReqData,                           // payload 타입
  { rejectValue: string }                 // thunkApi 설정
>(
  'auth/performLogin',
  async (credentials: LoginReqData, { rejectWithValue }) => {
    try {

      console.log('Login Request:', credentials);


      const response: ApiResponse<LoginResponse> = await post<LoginResponse>('pst', '/login/storeLogin', credentials);

      // 로그인 성공
      const { data } = response;

      console.log('Login Success:', data);

      if (data.code !==0)
        return rejectWithValue('로그인 실패: ' + data.message);


      // 토큰 저장
      tokenStore.set(data.data.accTkn, data.data.rfrTkn);

      console.log('Token Saved:', data.data.accTkn, data.data.rfrTkn);
      console.log('tokenStore is :', tokenStore.getAccessToken())
      return data;
    } catch (error: unknown) {
      // 에러 처리
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue('로그인 실패');
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.isLoggedIn = false;
      state.error      = null;
      tokenStore.clear();
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // 로그인 요청 중
    builder.addCase(performLogin.pending, (state) => {
      state.loading = true;
      state.error   = null;
    });

    // 로그인 성공
    builder.addCase(performLogin.fulfilled, (state) => {
      state.loading    = false;
      state.isLoggedIn = true;
      state.error      = null;
    });

    // 로그인 실패 (아이디/비번 틀림 등)
    builder.addCase(performLogin.rejected, (state, action) => {
      state.loading    = false;
      state.isLoggedIn = false;
      state.error      = action.payload || '로그인 실패';
    });
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
